import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GradeStatement, GradeStatementList} from './interface/grade-statement.interface';
import {Student} from './interface/roster.interface';
import {GradeStatementScenarioType} from './enum/grade-statement-scenario-type';

@Injectable()
export class GradeStatementService {
    constructor(private http: HttpClient) {
    }

    readonly gradeStatementScenarioType: GradeStatementScenarioType = GradeStatementScenarioType.getInstance();

    get(): Observable<GradeStatementList> {
        return this.http.get<GradeStatementList>('/api/gradeStatement');
    }

    findStatement(student: Student, gradeStatementList: GradeStatementList): GradeStatement {
        //show custom
        // if exists in grades for dialog then we need to pass the data to show
        const findStatements: Array<GradeStatement> = gradeStatementList.list;

        let localStatement: GradeStatement = null;
        const GDList = ['GD', 'WGD'];
        const IList = ['I', 'WI'];
        const IListFull = ['I', 'WI', 'IE', 'WIE'];
        const FNCList = ['F', 'NC'];


        if (student.shrtckgGCHGCode) {
            if (GDList.indexOf(student.gradeIGrade) >= 0) {
                localStatement = findStatements.find(
                    (item: GradeStatement) =>
                        item.gradeStatementText.gradeStatementScenarioType ==
                        this.gradeStatementScenarioType.gdGradeScenarioInitialGrade.statement
                );
            } else {
                if (
                    IListFull.indexOf(student.gradeBanner) >= 0 ||
                    (FNCList.indexOf(student.gradeBanner) >= 0 && ['IL'].indexOf(student.shrtckgGCHGCode) >= 0)
                ) {
                    if (student.shrtckgIncompleteExtDateGreaterThanToday) {
                        localStatement = findStatements.find(
                            (item: GradeStatement) =>
                                item.gradeStatementText.gradeStatementScenarioType ==
                                this.gradeStatementScenarioType.incompleteScenarioExtDateAfterToday.statement
                        );
                    } else {
                        // date already passed
                        localStatement = findStatements.find(
                            (item: GradeStatement) =>
                                item.gradeStatementText.gradeStatementScenarioType ==
                                this.gradeStatementScenarioType.incompleteScenarioExtDateBeforeToday.statement
                        );
                    }
                } else {
                    if (IList.indexOf(student.gradeIGrade) >= 0) {
                        localStatement = findStatements.find(
                            (item: GradeStatement) =>
                                item.gradeStatementText.gradeStatementScenarioType ==
                                this.gradeStatementScenarioType.incompleteScenarioBeforeFirstSubmitGrade.statement
                        );
                    }
                }
            }
        } else {
            if (GDList.indexOf(student.gradeIGrade) >= 0) {
                localStatement = findStatements.find(
                    (item: GradeStatement) =>
                        item.gradeStatementText.gradeStatementScenarioType ==
                        this.gradeStatementScenarioType.gdGradeScenarioInitialGrade.statement
                );
            }
            if (IList.indexOf(student.gradeIGrade) >= 0) {
                localStatement = findStatements.find(
                    (item: GradeStatement) =>
                        item.gradeStatementText.gradeStatementScenarioType ==
                        this.gradeStatementScenarioType.incompleteScenarioBeforeFirstSubmitGrade.statement
                );
            }
        }

        console.log('localStatement');
        console.log(localStatement);
        return localStatement;
    }
}
